/* global femcare, VideoPlayer */

femcare.video.platformVideo.initModalVideoPlayer = function () {

    this.$videoModal = $('#videoModal');

    this.modalPlayer = null;

    this.$modalPlayTriggers.on('click', $.proxy(function (event) {

        if (this.activePlayer !== null) {
            this.activePlayer.player.pause();
        }

        var $playButton = $(event.currentTarget);
        var $videoPlayer = $('<div class="video-player"></div>');
        $videoPlayer.attr('data-video-aspect-ratio', $playButton.attr('data-video-aspect-ratio'));
        $videoPlayer.attr('data-video-image', $playButton.attr('data-video-image'));
        $videoPlayer.attr('data-video-name', $playButton.attr('data-video-name'));
        $videoPlayer.attr('data-video-url-hls', $playButton.attr('data-video-url-hls'));
        $videoPlayer.attr('data-video-url-progressive', $playButton.attr('data-video-url-progressive'));
        this.$videoModal.find('.modal-body .video-player-parent').append($videoPlayer);

        var player = new VideoPlayer($videoPlayer[0], null, this.videoOptions);
        var playerId = VideoPlayer.getOrCreateId($videoPlayer[0]);

        this.modalPlayer = {
            player: player,
            playerId: playerId,
            $trigger: $playButton
        };

        this.$videoModal.modal('show');
    }, this));

    this.$videoModal.on('shown.bs.modal', $.proxy(function () {

        this.modalPlayer.player.play();

        this.activePlayer = this.modalPlayer;

        femcare.shared.pubsub.publish('PLATFORM_MODAL_VIDEO_PLAY', {
            player: this.activePlayer.player,
            playerId: this.activePlayer.playerId,
            $trigger: this.activePlayer.$trigger
        });

    }, this));

    this.$videoModal.on('hidden.bs.modal', $.proxy(function () {
        this.$videoModal.find('.modal-body .video-player-parent').empty();
        femcare.shared.pubsub.publish('PLATFORM_MODAL_VIDEO_FINISH', {
            player: this.activePlayer.player,
            playerId: this.activePlayer.playerId,
            $trigger: this.activePlayer.$trigger
        });

        this.activePlayer.player.destroy();
        this.modalPlayer = null;
        this.activePlayer = null;
    }, this));
};